import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, useDeviceType } from '@cian/ui-kit';
import { selectIsModal, selectWidgetError, selectWidgetMode, selectWidgetStatus } from '../../../selectors/layout';
import { ActionButtons } from './ActionButtons';
import { getApplyButtonText } from './utils';
import { TThunkDispatch } from '../../../types/redux';
import { startPaymentThunk } from '../../../thunks/startPayment';
import { closeModalThunk } from '../../../thunks/closeModal';
import { EWidgetStatus } from '../../../types/redux/layout';
import { trackCancelButtonClick, trackConfirmButtonClick } from '../../../trackers';
import { selectPackageId, selectPaymentInitSource } from '../../../selectors/checkout';
import { selectActivePaymentMethod } from '../../../selectors/paymentMethods';

export const ActionButtonsContainer = () => {
  const deviceType = useDeviceType();
  const widgetMode = useSelector(selectWidgetMode);
  const isModal = useSelector(selectIsModal);
  const widgetStatus = useSelector(selectWidgetStatus);
  const widgetError = useSelector(selectWidgetError);
  const paymentInitSource = useSelector(selectPaymentInitSource);
  const { type: paymentMethodType } = useSelector(selectActivePaymentMethod);
  const packageId = useSelector(selectPackageId);

  const isLoading = widgetStatus === EWidgetStatus.Loading;
  const isFullWidthButton = deviceType === 'phone';

  const applyButtonText = getApplyButtonText(widgetMode);

  const dispatch: TThunkDispatch = useDispatch();

  const handleApplyClick = React.useCallback(() => {
    trackConfirmButtonClick({ paymentInitSource, paymentMethodType, packageId });

    dispatch(startPaymentThunk);
  }, [dispatch, paymentInitSource, paymentMethodType, packageId]);

  const handleCancelClick = React.useCallback(() => {
    trackCancelButtonClick({ paymentInitSource, paymentMethodType });

    dispatch(closeModalThunk());
  }, [dispatch, paymentInitSource, paymentMethodType]);

  return (
    <ActionButtons error={widgetError}>
      {isModal && (
        <Button
          theme="fill_secondary"
          size="M"
          fullWidth={isFullWidthButton}
          disabled={isLoading}
          onClick={handleCancelClick}
          data-testid="widget|button|cancel"
        >
          Отмена
        </Button>
      )}

      <Button
        theme="fill_primary"
        size="M"
        fullWidth={isFullWidthButton}
        loading={isLoading}
        disabled={isLoading}
        onClick={handleApplyClick}
        data-testid="widget|button|apply"
      >
        {applyButtonText}
      </Button>
    </ActionButtons>
  );
};
